/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class ReportBrowser {
  async LoadReports() : Promise<Array<st.ReportGroup>> {
    return await componentApi.call('st', 'report-browser', 'ReportBrowser', 'LoadReports', {
    });
  }
  async PublishReport(reportGu : string, padPath : string, publishToPad : boolean, overrideDefault : boolean) : Promise<st.ReportInfoCard> {
    return await componentApi.call('st', 'report-browser', 'ReportBrowser', 'PublishReport', {
      reportGu,
      padPath,
      publishToPad,
      overrideDefault,
    });
  }
  async EditReport(reportGu : string, name : string, number : string, reportGroupOverride : string, thumbnailBase64 : string, extension : string) : Promise<st.ReportInfoCard> {
    return await componentApi.call('st', 'report-browser', 'ReportBrowser', 'EditReport', {
      reportGu,
      name,
      number,
      reportGroupOverride,
      thumbnailBase64,
      extension,
    });
  }
  async EditReportGroup(reportGroupDefGU : string, description : string, thumbnailBase64 : string, thumbnailExtension : string) : Promise<st.ReportGroup> {
    return await componentApi.call('st', 'report-browser', 'ReportBrowser', 'EditReportGroup', {
      reportGroupDefGU,
      description,
      thumbnailBase64,
      thumbnailExtension,
    });
  }
  async DeleteReport(reportGu : string) : Promise<boolean> {
    return await componentApi.call('st', 'report-browser', 'ReportBrowser', 'DeleteReport', {
      reportGu,
    });
  }
  async CopyReport(reportGu : string, number : string, name : string) : Promise<st.ReportInfoCard> {
    return await componentApi.call('st', 'report-browser', 'ReportBrowser', 'CopyReport', {
      reportGu,
      number,
      name,
    });
  }
  async Create(name : string, number : string, queryType : string, query : string, orientation : string, createDefaultLayout : boolean) : Promise<st.ReportInfoCard> {
    return await componentApi.call('st', 'report-browser', 'ReportBrowser', 'Create', {
      name,
      number,
      queryType,
      query,
      orientation,
      createDefaultLayout,
    });
  }
  async GetSecurityInfo() : Promise<st.ReportBrowserSecurityInfo> {
    return await componentApi.call('st', 'report-browser', 'ReportBrowser', 'GetSecurityInfo', {
    });
  }
  async SetReportThumbnail(reportGu : string, base64Img : string, extension : string) : Promise<string> {
    return await componentApi.call('st', 'report-browser', 'ReportBrowser', 'SetReportThumbnail', {
      reportGu,
      base64Img,
      extension,
    });
  }
  async LoadPreviousRuns(reportGu : string) : Promise<Array<st.JobQueueRunInfo>> {
    return await componentApi.call('st', 'report-browser', 'ReportBrowser', 'LoadPreviousRuns', {
      reportGu,
    });
  }
}
export default new ReportBrowser()
